var timelineData = {
  name: 'timeline',
  data: [{
    fontFamily: 'MicrosoftYaHei',
    fontSize: 12,
    border: 2,
    fontColor: '#6a6a6a',
    /* 圆点的中心点颜色和外圈颜色 */
    blueNodeBorderColor: 'rgba(6,135,255,0.3)',
    blueNodeBgColor: '#0687FF',
    greenNodeBorderColor: 'rgba(45,195,128,0.3)',
    greenNodeBgColor: '#2DC380',
    redNodeBorderColor: 'rgba(255,0,0,0.3)',
    redNodeBgColor: '#f00',
    yellowNodeBorderColor: 'rgba(255,180,0,0.3)',
    yellowNodeBgColor: '#FFBC00'
  }]
};
export default timelineData;